import { Component, OnInit } from '@angular/core';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit {
  transactions : any[] | undefined;
  presentbusinessid : any;

  constructor( public service:SharkifyAiSerivceService ) { }
  ngOnInit(): void {
    this.presentbusinessid = localStorage.getItem('CheckBusinessInfoId')
    const userId = localStorage.getItem('UserId');
    const userIdNumber = Number(userId);
    this.service.getTransactionsByUserId(userIdNumber).subscribe(
      data => {
        this.transactions = data;
        console.log(data);
      },
      error => {
        console.error('Error fetching transactions', error);
      }
    );
    
  }

}
